import { Component, Input, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { debounceTime } from "rxjs";
import { EvaluationService } from "../services/evaluation.service";
import { SnackBarService } from "../services/snack-bar.service";
import { Router } from "@angular/router";
import { NavigationService } from "../services/navigation.service";

@Component({
  selector: "app-designer",
  templateUrl: "./designer.component.html",
  styleUrls: ["./designer.component.css"],
})
export class DesignerComponent implements OnInit {
  @Input() customLogo: any; //todo
  @Input() evaluationId: string;
  @Input() tokensDictionary: Record<string, string> | null;
  @Input() evaluationFormData: any;

  status: string;
  questionTypes: Array<Record<string, string>> = [
    { value: "RADIO", viewValue: "Radio" },
    { value: "BOOLEAN", viewValue: "Boolean" },
    { value: "RANGE", viewValue: "Range" },
    { value: "TEXT", viewValue: "Text" },
    // { value: "MULTISELECT", viewValue: "Multiselect" },
  ];

  languages = [
    { code: "de", label: "DE", placeholder: "Please write in German" },
    { code: "en", label: "EN", placeholder: "Please write in English" },
    { code: "uk", label: "UA", placeholder: "Please write in Ukrainian" },
    { code: "ru", label: "RU", placeholder: "Please write in Russian" },
    { code: "ar", label: "AR", placeholder: "Please write in Arabic" },
  ];

  tokenTypes: Array<{ code: string; label: string }> = [];

  myForm: FormGroup;

  pagesValidator(control: AbstractControl) {
    const pages = control.value;

    if (!Array.isArray(pages) || pages.length === 0) {
      return { pagesRequired: true };
    }
    for (const page of pages) {
      if (!page.title || !page.title.de) {
        return { titleDeRequired: true };
      }

      const questions = page.questions;

      if (!questions.length) {
        return { questionsRequired: true };
      } else {
        const isEveryQuestionHaveOption = questions.every((questionItem) => {
          if (questionItem?.type === "TEXT") {
            return true;
          }
          return !!questionItem.options?.length;
        });

        if (!isEveryQuestionHaveOption) {
          return { optionsRequired: true };
        }
        const isEveryOptionsHaveTitle = questions.every((item) => {
          return item.options?.every((option) => !!option.title?.de);
        });

        if (!isEveryOptionsHaveTitle) {
          return { optionTitleRequired: true };
        }
      }
    }
    return null;
  }

  constructor(
    private evaluationService: EvaluationService,
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private snackbarService: SnackBarService,
  ) {}

  ngOnInit() {
    console.log("This dictionary>>>", this?.tokensDictionary);
    this.tokenTypes = [
      {
        code: "CUSTOMER",
        label: this?.tokensDictionary?.["CUSTOMER"] || "TYPE_1",
      },
      {
        code: "EMPLOYEE",
        label: this?.tokensDictionary?.["EMPLOYEE"] || "TYPE_2",
      },
      { code: "TEAM", label: this.tokensDictionary?.["TEAM"] || "TYPE_3" },
      {
        code: "MANAGEMENT",
        label: this?.tokensDictionary?.["MANAGEMENT"] || "TYPE_4",
      },
    ];

    this.myForm = this.fb.group({
      title: ["", Validators.required],
      pages: this.fb.array([], this.pagesValidator),
    });

    this.subscribeFormValues();
    this.getSurveyDraft();
    this.getEvaluationById();
  }

  //@TODO potentially wrong approach
  getSurveyDraft() {
    if (this.evaluationId) {
      this.evaluationService
        .readSurveyDraftOfEvaluation(this.evaluationId)
        .subscribe((result) => {
          const data = JSON.parse(result);
          this.myForm.patchValue({
            title: data?.title,
          });

          if (data?.pages?.length) {
            data?.pages?.forEach((page) => {
              this.pages.push(
                this.fb.group({
                  title: this.getTitlesForNewEntity(page?.title),
                  questions: page?.questions?.length
                    ? this.fb.array(
                        page?.questions?.map((question) =>
                          this.fb.group({
                            tips: this.getTitlesForNewEntity(
                              question?.tips,
                              false,
                            ),
                            indicator: [
                              question?.indicator || "",
                              Validators.required,
                            ],
                            type: [question?.type || "RADIO", []],
                            title: this.fb.group({
                              EMPLOYEE: this.getTitlesForNewEntity(
                                question?.title?.["EMPLOYEE"],
                                this.checkRequiredFieldByCustomTokenName(
                                  this.evaluationFormData?.facilities,
                                  "generatedEmployeeTokens",
                                ),
                                true,
                              ),
                              CUSTOMER: this.getTitlesForNewEntity(
                                question?.title?.["CUSTOMER"],
                                this.checkRequiredFieldByCustomTokenName(
                                  this.evaluationFormData?.facilities,
                                  "generatedCustomerTokens",
                                ),
                                true,
                              ),
                              TEAM: this.getTitlesForNewEntity(
                                question?.title?.["TEAM"],
                                this.checkRequiredFieldByCustomTokenName(
                                  this.evaluationFormData?.facilities,
                                  "generatedTeamTokens",
                                ),
                                true,
                              ),
                              MANAGEMENT: this.getTitlesForNewEntity(
                                question?.title?.["MANAGEMENT"],
                                this.checkRequiredFieldByCustomTokenName(
                                  this.evaluationFormData?.facilities,
                                  "generatedManagementTokens",
                                ),
                                true,
                              ),
                            }),
                            options: question?.options?.length
                              ? this.fb.array(
                                  question?.options?.map((option) =>
                                    this.fb.group({
                                      value: option?.value || 0,
                                      title: this.getTitlesForNewEntity(
                                        option?.title,
                                      ),
                                    }),
                                  ),
                                )
                              : this.fb.array([]),
                          }),
                        ),
                      )
                    : this.fb.array([]),
                }),
              );
            });
          }
        });
    }
  }

  //@TODO reuse for arrays
  getTitlesForNewEntity(
    entity?: any,
    hasRequiredField = true,
    autoDisableDeRequired = false,
  ): FormGroup {
    const deValue = entity?.de || "";

    return this.fb.group({
      de: [
        deValue,
        hasRequiredField
          ? autoDisableDeRequired
            ? !!deValue
              ? Validators.required
              : []
            : Validators.required
          : [],
      ],
      en: [entity?.en || "", []],
      ru: [entity?.ru || "", []],
      ar: [entity?.ar || "", []],
      uk: [entity?.uk || "", []],
    });
  }

  addPage() {
    this.pages.push(
      this.fb.group({
        title: this.getTitlesForNewEntity(),
        questions: this.fb.array([]),
      }),
    );
  }

  addQuestion(pageIndex: number) {
    this.getQuestions(pageIndex).push(
      this.fb.group({
        tips: this.getTitlesForNewEntity(Object, false),
        indicator: ["", Validators.required],
        type: ["RADIO", []],
        title: this.fb.group({
          EMPLOYEE: this.getTitlesForNewEntity(
            Object,
            this.checkRequiredFieldByCustomTokenName(
              this.evaluationFormData?.facilities,
              "generatedEmployeeTokens",
            ),
          ),
          CUSTOMER: this.getTitlesForNewEntity(
            Object,
            this.checkRequiredFieldByCustomTokenName(
              this.evaluationFormData?.facilities,
              "generatedCustomerTokens",
            ),
          ),
          TEAM: this.getTitlesForNewEntity(
            Object,
            this.checkRequiredFieldByCustomTokenName(
              this.evaluationFormData?.facilities,
              "generatedTeamTokens",
            ),
          ),
          MANAGEMENT: this.getTitlesForNewEntity(
            Object,
            this.checkRequiredFieldByCustomTokenName(
              this.evaluationFormData?.facilities,
              "generatedManagementTokens",
            ),
          ),
        }),
        options: this.fb.array([]),
      }),
    );
  }

  addQuestionOption(pageIndex: number, questionIndex: number) {
    this.getQuestionOptions(pageIndex, questionIndex).push(
      this.fb.group({
        value: 0,
        title: this.getTitlesForNewEntity(),
      }),
    );
  }

  removePage(index: number) {
    this.pages.removeAt(index);
  }

  removeQuestion(pageIndex, questionIndex) {
    this.getQuestions(pageIndex).removeAt(questionIndex);
  }

  removeQuestionsOption(pageIndex, questionIndex, optionIndex) {
    this.getQuestionOptions(pageIndex, questionIndex).removeAt(optionIndex);
  }

  get pages() {
    return this.myForm.get("pages") as FormArray;
  }

  get title() {
    return this.myForm.get("title");
  }

  getQuestions(pageIndex: number) {
    return this.pages.at(pageIndex).get("questions") as FormArray;
  }

  getQuestionOptions(pageIndex: number, questionIndex) {
    return this.getQuestions(pageIndex)
      .at(questionIndex)
      .get("options") as FormArray;
  }

  checkTitleFromPageIsValid() {
    const languageCategories = this.pages.value.filter((element: any) => {
      return Object.values(element.title).filter(Boolean).length;
    });

    return languageCategories.length;
  }

  saveSurvey() {
    const dataToSend = {
      creationDate: new Date(),
      title: this.myForm.value?.title,
      pages: this.myForm.value?.pages?.map((page) => ({
        titles: this.evaluationService.mapEntityTitlesReverse(page?.title),
        questions: page?.questions?.map((question) => ({
          type: question?.type,
          indicator: question?.indicator,
          tips: this.evaluationService.mapEntityTitlesReverse(question?.tips),
          titles: this.evaluationService.mapEntityTokenTypeTitles(
            question?.title,
          ),
          options: question?.options?.map((option) => ({
            value: String(option?.value),
            titles: this.evaluationService.mapEntityTitlesReverse(
              option?.title,
            ),
          })),
        })),
      })),
    };
    return dataToSend;
  }

  async onSubmit() {
    this.evaluationService
      .uploadSurvey(Number(this.evaluationId), this.saveSurvey())
      .subscribe(() => {
        this.evaluationService
          .uploadSurveyDraft(this.evaluationId, "  ")
          .subscribe(
            () => {
              this.changeEvaluationState();
              this.myForm.setErrors({ invalid: true });
            },
            (error) => {
              this.snackbarService.error("Failed to save survey draft" + error);
            },
          );
      });
  }

  subscribeFormValues() {
    this.myForm.valueChanges.pipe(debounceTime(3000)).subscribe((value) => {
      if (this.evaluationId) {
        this.evaluationService
          .uploadSurveyDraft(this.evaluationId, JSON.stringify(value))
          .subscribe(
            () => {},
            () => {
              this.snackbarService.error("Failed to save survey draft");
            },
          );
      }
    });
  }

  changeEvaluationState() {
    this.evaluationService
      .changeEvaluationState(this.evaluationId, "PUBLISHED")
      .subscribe(
        () => {
          this.router
            .navigate([NavigationService.TOKENS + "/" + this.evaluationId])
            .then();
        },
        () => {
          this.snackbarService.error("Failed to publish evaluation");
        },
      );
  }

  getEvaluationById() {
    this.evaluationService
      .getEvaluationById(this.evaluationId)
      .subscribe((evaluation) => {
        this.status = evaluation?.state;
      });
  }
  getDisabledForm() {
    return (
      this.myForm.invalid || this.status === "PUBLISHED" || !this.pages.length
    );
  }

  get currentLanguage() {
    let language = "";

    if (localStorage.getItem("lang")) {
      language = String(localStorage.getItem("lang"));
    }

    return language;
  }

  checkRequiredFieldByCustomTokenName(tokens: any[], searchType: string) {
    return tokens?.some((item) => !!item?.[searchType]);
  }

  isGermanRequired(
    pageIndex: number,
    questionIndex: number,
    tokenTypeCode: string,
  ): boolean {
    const control = this.myForm.get(
      [
        "pages",
        pageIndex,
        "questions",
        questionIndex,
        "title",
        tokenTypeCode,
        "de",
      ].join("."),
    );
    return control?.hasValidator(Validators.required) ?? false;
  }

  toggleGermanRequired(
    pageIndex: number,
    questionIndex: number,
    tokenTypeCode: string,
  ): void {
    const control = this.myForm.get(
      [
        "pages",
        pageIndex,
        "questions",
        questionIndex,
        "title",
        tokenTypeCode,
        "de",
      ].join("."),
    );
    if (control) {
      if (control.hasValidator(Validators.required)) {
        control.removeValidators(Validators.required);
      } else {
        control.addValidators(Validators.required);
      }
      control.updateValueAndValidity();
    }
  }
}
